import { hueForLivro } from '@/design/hues';

/**
 * Faixa infinita com os títulos do acervo, cada um na cor do mês em que
 * foi lido. A lista é duplicada porque o loop desliza -50%: sem a
 * segunda cópia o fim da fita aparece.
 */
export const Marquee = ({ livros = [] }) => {
  if (livros.length < 2) return null;

  const fita = [...livros, ...livros];

  return (
    <div className="banda-rosa overflow-hidden py-5">
      <div
        className="flex w-max animate-[club-marquee_34s_linear_infinite] hover:[animation-play-state:paused]"
        data-club-marquee
      >
        {fita.map((livro, i) => (
          <span
            key={`${livro.id}-${i}`}
            className="flex items-center gap-5 pr-5"
            data-hue={hueForLivro(livro)}
            aria-hidden={i >= livros.length}
          >
            <b className="type-club whitespace-nowrap text-[clamp(22px,3.6vw,44px)] text-[var(--banda-titulo)]">
              {livro.title}
            </b>
            <i
              className="h-2.5 w-2.5 shrink-0 rounded-full bg-[var(--banda-acento)]"
              aria-hidden="true"
            />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
